import createIcon from '../../createIcon';

/**
 * @component @name Storage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyMEgyMlYxNkgyVjIwWk00IDE3SDZWMTlINFYxN1pNMiA0VjhIMjJWNEgyWk02IDdINFY1SDZWN1pNMiAxNEgyMlYxMEgyVjE0Wk00IDExSDZWMTNINFYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Storage = createIcon('Storage', [
  [
    'path',
    {
      d: 'M2 20H22V16H2V20ZM4 17H6V19H4V17ZM2 4V8H22V4H2ZM6 7H4V5H6V7ZM2 14H22V10H2V14ZM4 11H6V13H4V11Z',
      key: '2wwi4x',
    },
  ],
]);

export default Storage;
